import { render } from "./TheatrePage.vue?vue&type=template&id=463de5d5&scoped=true"
import script from "./TheatrePage.vue?vue&type=script&lang=js"
export * from "./TheatrePage.vue?vue&type=script&lang=js"

import "./TheatrePage.vue?vue&type=style&index=0&id=463de5d5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-463de5d5"]])

export default __exports__